import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import LogoFK from "../../assets/logo/logo-FK.png";
import LogoKA from "../../assets/logo/logo-KA.png";
import LogoMK from "../../assets/logo/logo-MK.png";
import LogoMaisQuePet from "../../assets/logo/logo-mais-que-pet.png";
import LogoCometas from "../../assets/logo/logo-pequenos-cometas.png";
import "./FooterBar.css";

export default function FooterBar(props) {
  return (
    <div>
      <Container
        style={{ background: props.footerBarBG }}
        fluid
        className="footer-bar-company-section"
      >
        <Container>
          <Row className="footer-bar-first-row">
            <Col>
              <h4 style={{ color: props.titleColor }}>
                Conheça nossas Empresas e Projetos
              </h4>
            </Col>
          </Row>
          <Row className="footer-bar-second-row">
            <Col className="footer-bar-second-row-col">
              <Link to="/servicos/funeraria-krause/">
                <img
                  src={LogoFK}
                  alt="Logo Funerária Krause"
                  className="footer-bar-company-logo"
                />
              </Link>
            </Col>
            <Col className="footer-bar-second-row-col">
              <Link to="/servicos/krause-assistencial/">
                <img
                  src={LogoKA}
                  alt="Logo Krause Assistencial"
                  className="footer-bar-company-logo"
                />
              </Link>
            </Col>
            <Col className="footer-bar-second-row-col">
              <Link to="/servicos/memorial-krause/">
                <img
                  src={LogoMK}
                  alt="Logo Memorial Krause"
                  className="footer-bar-company-logo"
                />
              </Link>
            </Col>
            <Col className="footer-bar-second-row-col">
              <Link to="/servicos/mais-que-pet/">
                <img
                  src={LogoMaisQuePet}
                  alt="Logo Mais Que Pet"
                  className="footer-bar-company-logo"
                />
              </Link>
            </Col>
            <Col className="footer-bar-second-row-col">
              <Link to="/servicos/pequenos-cometas/">
                <img
                  src={LogoCometas}
                  alt="Logo Pequenos Cometas"
                  className="footer-bar-company-logo"
                />
              </Link>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}
